import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { selectChapterPostListItems } from "../../../../../../redux/chapter/posts/selector";
import { chapterPost } from "../../../../../../redux/chapter/posts/action";


const Posts = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

  const PostsItems = useSelector(selectChapterPostListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'ChapterTopicName', headerName: 'Topic Name' },
      {
        field: 'Text', headerName: 'Text', searchField: 'Text', filter: true,
        filterType: 'text'
      },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },



    ]);
  }


  const handleSearch = (data: any) => {

    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Text",
        FieldText: "Text",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(chapterPost.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/posts/list`, entity: 'chapterPost', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  const fetchPosts = () => {
    dispatch(chapterPost.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/posts/list`, entity: 'chapterPost', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }

  const handleReloadData = () => {
    fetchPosts()
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }



  const handleAdd = () => {
    navigate(`${0}`);
  };

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Forum Posts</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];
  useEffect(() => {
    createColumnDefs()
    fetchPosts()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(chapterPost.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/posts/delete`,
      entity: 'chapterPost',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.Id
          }

        ]
      }
    })).then(() => {
      fetchPosts()
    });
  }
  return (
    <>
      {PostsItems?.isLoading ? <PageLoader /> :
        <Table enableFilter={true}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} columnData={columnDefs} rowData={PostsItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={PostsItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Posts" />

      }
    </>
  );
};

export default Posts;